import axios from "axios";
import { getApiBaseUrl } from "./config";

const BASE_URL = getApiBaseUrl();

export async function fetchSession() {
  const response = await axios.get(`${BASE_URL}/api/me`, {
    withCredentials: true,
  });

  return response.data;
}

export async function logoutSession(email) {
  await axios.post(
    `${BASE_URL}/api/logout`,
    { email },
    {
      withCredentials: true,
    }
  );
}
